import { POST } from "../APiHelper/API";

export const getPitchCondition = (stadium_id, onSuccess, onError) => {
  const data = {
    stadium_id: stadium_id,
  };
  POST(`/api/v1/games/pitch_conditions`, data, onSuccess, onError);
};
